'use client';
// import CardSkeleton from '@/modules/product/components/card/product/CardSkelenton';
import Image from '@/grandus-utils/wrappers/image/Image';
import Labels from '@/app/components/product/labels/Labels';
import Availability from '@/app/components/product/card/availability/Availability';
import Prices from '@/app/components/product/card/prices/Prices';

import styles from './Card.module.scss';
import { useTranslation } from '@/app/i18n/client';
import isFunction from 'lodash/isFunction';
import Link from 'next/link';

const Card = ({
  product,
  isLoading,
  options,
  isSimple = false,
  className = '',
  onClick = null,
}) => {
  const { t } = useTranslation();

  const linkProps = {
    href: `/produkt/${product?.urlTitle}`,
    'aria-label': `link to ${product?.name}`,
    title: product?.name ?? '',
  };

  if (isFunction(onClick)) {
    linkProps.onClick = onClick;
  }

  return (
    <div
      className={`${styles.card} ${className}`}
    >
      <Link {...linkProps}>&nbsp;</Link>
      {isLoading ? null : (
        <>
          <div className={styles.image}>
            {product.photo ? (
              <div className="w-full flex justify-center">
                <Image
                  width={150}
                  height={150}
                  photo={product?.photo}
                  suffix="__cropped@2x"
                  type={'png'}
                  title={product?.name}
                  alt={product?.name ?? 'product'}
                  priority={options?.isFirst}
                />
              </div>
            ) : (
              ''
            )}
            {isSimple === false ?
              <Labels labels={product?.labels} discount={product?.discount ?? null} showText={false} /> : null}
          </div>
          <div className={styles.content}>
            {/*<strong className={styles.brand}>{product.brand.name}</strong>*/}
            <h6>{product?.name}</h6>
            {/*<p className={styles.description}>{product?.shortDescription ? product.shortDescription.substring(0, 80) + '... ' : ''}</p>*/}
            {/*{isSimple === false ? <CardParameters parameters={product?.cardParameters} className={styles?.parameters}/> : null}*/}
            <Prices
              product={product}
              className={'mb-0 !pb-1 !justify-start !items-center [&>div>br]:hidden [&>div:not(last-child)]:pe-2 text-white'}
            />
            <Availability product={product} />
          </div>
        </>
      )}
    </div>
  );
};
export default Card;
